import Header from "../components/header.jsx";
import Sidebar from "../components/sidebar.jsx";
import FreeCustomer from "../components/freeConnection.jsx";
import Footer from "../components/footer.jsx";

function FreeCustomerpage() {
    return (
        <div>
        <div className='wrapper'>
          <Header />
          <Sidebar /> 
          <FreeCustomer/> 
        </div>
        <Footer /> 
      </div>
      // <Login/>
      );
}
export default FreeCustomerpage;
